import {
  Breadcrumbs,
  Link,
  Divider as MuiDivider,
  Typography,
  styled,
  TextField,
} from "@material-ui/core";

import CustomAlert from "../components/CustomAlert";
import CustomTable from "../../components/GovGrMaterialTable";
import Edit from "@material-ui/icons/Edit";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import { fetchEmails } from "../../services/emailsService";
import queryFunction from "../../utils/queryFunction";
import { spacing } from "@material-ui/system";
import useLocale from "../../hooks/useLocale";
import { useState } from "react";
import GovGrCard from "../../components/GovGrCard";
import { useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import { portAuthoritySort } from "../../utils/portAuthoritySort";
import { fetchPortAuthorities } from "../../services/portAuthoritiesService";
import { useQuery } from "react-query";
import { useEffect } from "react";

const Divider = styled(MuiDivider)(spacing);

const Emails = () => {
  const auth_level = useSelector(
    (state) => state?.authReducer?.user?.auth_level
  );

  const [portAuthId, setportAuthId] = useState(
    useSelector((state) => state?.authReducer?.user?.port_auth_id)
  );
  const { t } = useLocale();
  const [isError, setIsError] = useState(false);
  const [, setIsViewDialogOpen] = useState(false);

  const {
    data: PortAuthorities,
    isError: isErrorFetching,
    isLoading,
    refetch,
  } = useQuery("portAuthorities", fetchPortAuthorities);
  const portAuthoritiesSorted = portAuthoritySort(PortAuthorities);

  useEffect(() => {
    if (auth_level === 0) {
      setportAuthId(null);
    }
  }, [auth_level]);

  return (
    <>
      <Helmet title={t("Emails")} />

      <Typography variant="h3" gutterBottom display="inline">
        {t("Emails")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>

        <Typography>{t("Emails")}</Typography>
      </Breadcrumbs>
      <Divider my={6} />

      <CustomAlert
        open={isError}
        close={() => {
          setIsError(false);
        }}
        message={t("A network error occured, please try again later")}
      />
      <GovGrCard>
        {auth_level === 0 ? (
          <Autocomplete
            id="combo-box-demo"
            onChange={(event, newValue) => {
              setportAuthId(newValue?.id);
            }}
            options={portAuthoritiesSorted || []}
            getOptionLabel={(option) => option?.dscr}
            style={{ width: 300, marginTop: 10 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Port Authorities")}
                variant="outlined"
              />
            )}
          />
        ) : null}
        <CustomTable
          options={{
            showTitle: false,
          }}
          data={(query) =>
            queryFunction(query, fetchEmails, setIsError, portAuthId)
          }
          key={portAuthId}
          columns={[
            {
              title: "ID",
              field: "id",
            },
            {
              title: t("Application id"),
              field: "appl_id",
            },
            {
              title: t("Sent date"),
              field: "sent_dt",
            },
            {
              title: t("Email body"),
              field: "sent_email",
            },
          ]}
        />
      </GovGrCard>
    </>
  );
};

export default Emails;
